import React from "react";
import "./index.scss";

export default function PageContainer ({children}) {
    return <main>{children}</main>
}